import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EventOccurrenceEntity } from './event-occurrence.entity';
import { EventSubtaskEntity } from './event-subtask.entity';

@Index('_fk__event_occurrence__id', ['fkEventOccurrenceId'], {})
@Index('_fk__event_subtask__id', ['fkEventSubtaskId'], {})
@Entity('_event_occurrence_subtask')
export class EventOccurrenceSubtaskEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__event_occurrence__id',
		nullable: true,
		unsigned: true,
	})
	public fkEventOccurrenceId!: number | null;

	@Column('int', {
		name: '_fk__event_subtask__id',
		nullable: true,
		unsigned: true,
	})
	public fkEventSubtaskId!: number | null;

	@Column('int', {
		name: '_fk__workd__user__id_completed',
		nullable: true,
		unsigned: true,
	})
	public fkWorkdUserIdCompleted!: number | null;

	@Column('datetime', { name: '_completedDateTime', nullable: true })
	public completedDateTime!: Date | null;

	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@ManyToOne(
		() => EventOccurrenceEntity,
		(eventOccurrence) => eventOccurrence.eventOccurrenceSubtasks,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__event_occurrence__id', referencedColumnName: 'id' },
	])
	public fkEventOccurrence!: EventOccurrenceEntity;

	@ManyToOne(
		() => EventSubtaskEntity,
		(eventSubtask) => eventSubtask.eventOccurrenceSubtasks,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__event_subtask__id', referencedColumnName: 'id' }])
	public fkEventSubtask!: EventSubtaskEntity;
}
